import { css } from '@linaria/atomic';
import { theme } from '@frontend/theme';

export type HeadingStylesProps = {
  level: 1 | 2 | 3;
};

const headingBase = css`
  font-weight: ${theme.font.weight.bold};
  line-height: ${theme.font.lineHeight};
  font-family: ${theme.font.family};
  margin: 0;
`;

const headingLevel1 = css`
  font-size: ${theme.font.size.h1};
`;

const headingLevel2 = css`
  font-size: ${theme.font.size.h2};
`;

const headingLevel3 = css`
  font-size: ${theme.font.size.h3};
`;

const levelStyles: Record<1 | 2 | 3, string> = {
  1: headingLevel1,
  2: headingLevel2,
  3: headingLevel3,
};

export const HeadingStyles = {
  heading: ({ level }: HeadingStylesProps): [string, string] => [headingBase, levelStyles[level]],
};
